import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useMetaTags = ({ title, description, canonicalUrl, robots }) => {
  const location = useLocation();

  useEffect(() => {
    // Update title if provided
    if (title) {
      document.title = title;
    }

    // Update meta description if provided
    if (description) {
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      }
    }

    // Update or create canonical tag
    let canonicalTag = document.querySelector('link[rel="canonical"]');
    const url = canonicalUrl || `https://ktpbeautyclinic.co.uk${location.pathname}`;
    
    if (!canonicalTag) {
      canonicalTag = document.createElement('link');
      canonicalTag.rel = 'canonical';
      document.head.appendChild(canonicalTag);
    }
    canonicalTag.href = url;

    // Update robots directive if provided
    let robotsTag = null;
    let previousRobotsContent = null;
    if (robots) {
      robotsTag = document.querySelector('meta[name="robots"]');
      if (!robotsTag) {
        robotsTag = document.createElement('meta');
        robotsTag.name = 'robots';
        document.head.appendChild(robotsTag);
      }
      previousRobotsContent = robotsTag.getAttribute('content');
      robotsTag.setAttribute('content', robots);
    }

    // Cleanup function to reset meta tags when component unmounts
    return () => {
      const defaultTitle = 'Makeup, Aesthetics & More in Manchester | KTP Beauty Clinic';
      const defaultDescription = 'KTP Beauty Clinic in Manchester offers expert makeup artistry, advanced aesthetics treatments, and personalized beauty services. Our professional team combines artistry with clinical expertise to enhance your natural beauty.';
      
      document.title = defaultTitle;
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', defaultDescription);
      }

      // Reset canonical to homepage
      const canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) {
        canonical.href = 'https://ktpbeautyclinic.co.uk/';
      }

      if (robotsTag) {
        if (previousRobotsContent) {
          robotsTag.setAttribute('content', previousRobotsContent);
        } else {
          robotsTag.parentNode.removeChild(robotsTag);
        }
      }
    };
  }, [title, description, canonicalUrl, robots, location.pathname]);
};

export default useMetaTags;
